'use strict';
if (!window.Promise) {
  require('es6-promise').polyfill();
}
import axios from 'axios';

function validate() {
  return axios.get(`https://www.wix.com/_api/marketing-cookie-notification/allowed`, {withCredentials: true, headers: {'Content-Type': 'application/json'}});
}

export {validate};



// WEBPACK FOOTER //
// ./modules/geoValidator.js